export class EmailReportParams {
    constructor(accountId, fromDate, toDate, pdf, excel, emailIds, assetType, financialYear, emailID, filePath, subType, scripIdentifier, dpId, expiryMonth, underlyingAsset, isMTF, segment, dpType, entity, ledgerType, currentValue, holdingDetail, holdingSummary, duration) {
        this.accountId = accountId;
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.pdf = pdf;
        this.excel = excel;
        this.emailIds = emailIds;
        this.assetType =
            typeof assetType === "object" ? assetType.join(",") : assetType;
        this.financialYear = financialYear;
        this.emailID = emailID;
        this.filePath = filePath;
        this.subType = subType;
        this.scripIdentifier = scripIdentifier;
        this.dpId = dpId;
        this.expiryMonth = expiryMonth;
        this.underlyingAsset = underlyingAsset;
        this.isMtf = isMTF;
        this.segment = segment;
        this.dpType = dpType;
        this.entity = entity;
        this.ledgerType = ledgerType;
        this.currentValue = currentValue;
        this.holdingDetail = holdingDetail;
        this.holdingSummary = holdingSummary;
        this.duration = duration;
    }
}
